import { inject, Injectable } from '@angular/core';
import type { SpriNavigationItem } from '@spri/components/navigation';
import { SpriMockApiService } from '@spri/lib/mock-api';
import { RolesService } from 'app/core/auth/roles/roles.service';
import { UserRole } from 'app/core/auth/roles/user-role.enum';
import { cloneDeep } from 'lodash-es';
import { administratorNavigation } from './data/administrator';
import { clinicianNavigation } from './data/clinician';
import { receptionNavigation } from './data/reception';
import { researchNavigation } from './data/research';
import { superAdminNavigation } from './data/super-admin';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
  private readonly _spriMockApiService = inject(SpriMockApiService);
  private readonly _rolesService = inject(RolesService);

  constructor() {
    // Register Mock API handlers
    this.registerHandlers();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {
    // -----------------------------------------------------------------------------------------------------
    // @ Navigation - GET
    // -----------------------------------------------------------------------------------------------------
    this._spriMockApiService.onGet('api/common/navigation').reply(() => {
      // Since all navigation arrays are identical, we can return the same data for all variants
      const userRole = this._rolesService.getCurrentRole();
      let navigationData: SpriNavigationItem[] = [];
      if (userRole === UserRole.SUPER_ADMIN) {
        navigationData = cloneDeep(superAdminNavigation);
      } else if (userRole === UserRole.ADMINISTRATOR) {
        navigationData = cloneDeep(administratorNavigation);
      } else if (userRole === UserRole.RESEARCH) {
        navigationData = cloneDeep(researchNavigation);
      } else if (userRole === UserRole.RECEPTION) {
        navigationData = cloneDeep(receptionNavigation);
      } else if (userRole === UserRole.CLINICIAN) {
        navigationData = cloneDeep(clinicianNavigation);
      }

      // Return the response
      return [
        200,
        {
          compact: navigationData,
          default: navigationData,
          futuristic: navigationData,
          horizontal: navigationData,
        },
      ];
    });
  }
}
